// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"592":"group-user","638":"group-admin"}[chunkId] + "." + {"592":"6de4aa5c","638":"d2bed23c"}[chunkId] + ".js";
};